import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'

@Component
export class FilterEntitySearchMixin extends FilterComponentsMixin {
  @Prop() defaultSelected?: Array<number>

  protected get getDefaultSelected() {
    if (this.defaultSelected) {
      return this.defaultSelected
    }

    if (!!!this.model) {
      return []
    }

    if (Array.isArray(this.model)) {
      return this.model.map((item) => parseInt(item))
    }

    return [parseInt(this.model)]
  }
}